import React from 'react'
import styled from 'styled-components'
import { useStaticQuery, graphql } from 'gatsby'

import { Props } from 'types/types'

const Container = styled.div<Props>`
  width: 12rem;
  height: fit-content;
  margin-top: 0.35rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  filter: ${({ theme: { filters } }) => filters.pink};
`

const Link = styled.a`
  margin-bottom: 0;
`

const Image = styled.img`
  width: 2.5rem;
  height: 2.5rem;
`

interface Social {
  id: number
  title: string
  url: string
  images: {
    src: {
      publicURL: string
    }
    alt: string
  }
}

const Social = ({ filters, direction }: any) => {
  const datas = useStaticQuery(graphql`
    query {
      allMarkdownRemark(filter: { fileAbsolutePath: { regex: "/site/" } }) {
        edges {
          node {
            frontmatter {
              socials {
                id
                title
                url
                images {
                  src {
                    publicURL
                  }
                  alt
                }
              }
            }
          }
        }
      }
    }
  `)

  const socialDatas = datas.allMarkdownRemark.edges[0]

  const socialData = socialDatas.node.frontmatter.socials.map(
    ({ id, title, url, images }: Social) => (
      <Link key={id} href={url} title={title}>
        <Image src={images.src.publicURL} alt={images.alt} />
      </Link>
    ),
  )

  return (
    <Container filters={filters} style={{ flexDirection: direction }}>
      {socialData}
    </Container>
  )
}

export default Social
